class BuyItNowComponent extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.buy-it-now-button');
    if (!this.button) return;
    this.button.addEventListener('click', this.handleClick.bind(this));
    window.addEventListener('pageshow', () => this.button.removeAttribute('aria-busy'));
  }

  handleClick(event) {
    event.preventDefault();
    if (this.button.disabled || this.button.getAttribute('aria-busy') === 'true') return;

    const target =
      this.querySelector('more-payment-options-link a') ||
      this.querySelector('.shopify-payment-button__more-options') ||
      this.querySelector('.shopify-payment-button__button--unbranded');

    if (!target) {
      window.location.href = window.Shopify?.routes?.root
        ? `${window.Shopify.routes.root}checkout`
        : '/checkout';
      return;
    }

    this.button.setAttribute('aria-busy', 'true');
    target.click();
  }
}

if (!customElements.get('buy-it-now-component')) {
  customElements.define('buy-it-now-component', BuyItNowComponent);
}
